export default {
  "content": "<title>Star Half</title><path d=\"M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 48v316L118 464l54-160-140-96h172l52-160z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};